<template>
	<div>
		<v-tabs v-model="activeTab" background-color="whitesmoke" centered color="secondary" slider-color="secondary">
			<v-tab :key="0">اطلاعات نماینده</v-tab>
			<v-tab :key="1">اطلاعات تکمیلی</v-tab>
			<v-tab :key="2">تنظیمات وام های نماینده</v-tab>
			<v-tab :key="3" v-if="localData.id !== 0">تیکت ها</v-tab>
			<v-tab :key="4" v-if="localData.id !== 0 && checkActivePart('agentFactor')">صورتحساب کیف پولی</v-tab>

			<v-tabs-items v-model="activeTab" touchless class="mt-3">
				<v-tab-item :key="0">
					<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
						<v-card class="pa-3" color="#eee" v-if="localData.parents && localData.parents.length">
							نماینده های سطح بالاتر:
							<span class="grey--text" v-for="(parent, index) in localData.parents" :key="parent.id">{{
								parent.businessName }} ({{ parent.fullName }}) <small v-if="index < localData.parents.length - 1">/ </small> </span>
						</v-card>
						<v-row>
							<v-col cols="12" md="6">
								<v-text-field ref="username" class="left-input" v-model="localData.userName" label="نام کاربری" hint="نام کاربری به صورت خودکار پر می شود" persistent-hint disabled />
							</v-col>
							<v-col cols="12" md="6">
								<v-checkbox color="secondary" v-model="localData.isActive" :label="'اکانت فعال'" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="firstName" v-model="localData.firstName" label="نام نماینده*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام نماینده را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="businessName" v-model="localData.businessName" label="نام تجاری*" :error-messages="errorMessages" :rules="[() => !!localData.businessName || 'نام تجاری را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="nationalCode" v-model="localData.nationalCode" label="کد ملی*" maxlength="10" :error-messages="errorMessages" :rules="[(val) => !!val || 'کد ملی را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="shenasname" v-model="localData.shenasname" label="شماره شناسنامه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره شناسنامه را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر" />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" :error-messages="errorMessages" :rules="[(val) => !!val || 'موبایل را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="تلفن ثابت" />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field class="left-input" v-model="localData.email" :rules="[(val) => !val || (!!val && isEmailValid()) || 'فرمت ایمیل صحیح نمی باشد']" :error-messages="errorMessages" :type="'text'" label="ایمیل" />
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field class="left-input" v-model="localData.password" persistent-hint :hint="localData.id !== 0 ? 'در صورت خالی بودن پسورد تغییر نخواهد کرد' : 'حداقل 8 کاراکتر'" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[(val) => !!val || (localData.id != 0 && !val) || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="show1 ? 'text' : 'password'" name="password" label="کلمه عبور*" @click:append="show1 = !show1" />
							</v-col>
							<v-col cols="12" md="6" class="py-0">
								<v-text-field class="left-input" v-model="localData.confirmPassword" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="show2 ? 'text' : 'password'" name="confirmPassword" label="تکرار کلمه عبور*" @click:append="show2 = !show2" />
							</v-col>
							<v-col cols="12" md="2" class="">
								<v-text-field ref="city" v-model="localData.city" label="شهر*" :rules="[() => !!localData.city || 'شهر را وارد کنید']" />
							</v-col>
							<v-col cols="12" md="8" class="">
								<v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید']" />
							</v-col>
							<v-col cols="12" md="2" class="">
								<v-text-field ref="postalCode" v-model="localData.postalCode" label="کد پستی*" maxlength="10" :rules="[(val) => !!val || 'کد پستی را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="12" class="">
								<div style="border-radius: 5px;background:#eee;padding: 10px;">
									<div class="text-center secondary--text mb-2">شماره حساب ها</div>
									<v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
										<v-row>
											<v-col cols="12" md="5" class="py-0 my-0">
												<v-text-field v-model="item.accountNumber" label="شماره حساب/شبا*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید']" required />
											</v-col>
											<v-col cols="12" md="3" class="py-0 my-0">
												<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
											</v-col>
											<v-col cols="12" md="3" class="py-0 my-0">
												<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
											</v-col>
											<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
												<v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
													<v-icon dark>
														mdi-trash-can-outline
													</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-card>
									<div class="text-center mt-5">
										<v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
											<v-icon dark>
												mdi-plus-circle-outline
											</v-icon>
											شماره حساب جدید
										</v-btn>
									</div>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" md="12">
								<v-checkbox color="secondary" v-model="localData.smsActiveForMembers" :label="'پیامک ها و ایمیل های یادآوری به مشتریان و کد تائیدیه موبایل فعال باشد؟'" />
							</v-col>
						</v-row>
						<div class="mt-3">
							<small>*فیلدهای ستاره دار ضروری هستند.</small>
						</div>
					</v-form>
				</v-tab-item>
				<v-tab-item :key="1">
					<v-form ref="formMetaData" class="mx-2" lazy-validation @submit.prevent="submit">
						<v-row class="pt-4">
							<v-col cols="6">
								نوع شخص:
								<v-btn-toggle v-model="localData.metaData.agentType" borderless color="secondary">
									<v-btn :value="0">
										<span class="">حقیقی</span>
									</v-btn>

									<v-btn :value="1">
										<span class="">حقوقی</span>
									</v-btn>
								</v-btn-toggle>
							</v-col>
							<v-col cols="6" class="d-flex align-center">
								<span class="pt-2">نحوه فعالیت:</span>
								<v-checkbox color="secondary" v-model="localData.metaData.isPhysical" label="حضوری" :value="true" hide-details compact class="mr-2"></v-checkbox>
								<v-checkbox color="secondary" v-model="localData.metaData.isOnline" label="آنلاین" :value="true" hide-details compact class="mr-2"></v-checkbox>
							</v-col>
						</v-row>
						<v-row class="">
							<v-col cols="12" md="4" class="py-0 mx-0" v-if="localData.metaData.agentType === 1">
								<v-text-field class="mx-0" v-model="localData.metaData.companyName" label="نام شرکت" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام شرکت را وارد کنید']" focused required />
							</v-col>
							<v-col cols="12" md="4" class="py-0 mx-0" v-if="localData.metaData.agentType === 1">
								<v-text-field class="mx-0" v-model="localData.metaData.shenaseMelli" label="شناسه ملی" :error-messages="errorMessages" :rules="[(val) => !!val || 'شناسه ملی شرکت را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="4" class="py-0 mx-0" v-if="localData.metaData.agentType === 1">
								<v-text-field class="mx-0" v-model="localData.metaData.shomareSabt" label="شماره ثبت" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره ثبت شرکت را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="4" class="py-0 mx-0" v-if="localData.metaData.agentType === 1">
								<v-text-field class="mx-0" v-model="localData.metaData.signaturesOwnerNames" label="نام صاحبین امضا" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام صاحبین امضا را وارد کنید']" required />
							</v-col>
							<v-col cols="12" md="6" class="py-0 mx-0">
								<v-text-field class="left-input" placeholder="http://" v-model="localData.metaData.siteUrl" label="آدرس وب سایت: (با http شروع شود)" :rules="[(val) => !localData.metaData.isOnline || (localData.metaData.isOnline && !!val) || 'آدرس وب سایت را وارد کنید']" />
							</v-col>
							<v-col cols="12" md="12" class="pys-2 mx-0">
								<div class="">نوع محصولات کسب و کار:</div>
								<div class="d-flex flex-wrap">
									<v-checkbox color="secondary" v-for="service in Object.values(services)" :key="service.key" v-model="service.value" :label="service.title" :value="service.key" hide-details compact class="ml-2"></v-checkbox>
								</div>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12" class="">
								مدارک پیوستی
							</v-col>
							<v-col cols="12" md="3">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>لوگو</span>
								</div>
								<ImageUploader :downloadable="true" ref="thumbnailFileUploader" v-model="localData.metaData.thumbnailBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.thumbnailBase64)" @delete="() => localData.metaData.thumbnailFileName = ''" />
							</v-col>
							<v-col cols="12" md="3">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>{{ localData.metaData.agentType === 0 ? 'کارت ملی' : 'کارت ملی مدیر عامل'
									}}</span>
								</div>
								<ImageUploader :downloadable="true" ref="kartmelliFileUploader" v-model="localData.metaData.kartMelliBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.kartMelliBase64)" @delete="() => localData.metaData.kartMelliFileName = ''" />
							</v-col>
							<v-col cols="12" md="3" v-if="localData.metaData.agentType === 0">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>اجاره نامه یا سند</span>
								</div>
								<ImageUploader :downloadable="true" ref="ejarenameFileUploader" v-model="localData.metaData.ejarenameBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.ejarenameBase64)" @delete="() => localData.metaData.ejarenameFileName = ''" />
							</v-col>
							<v-col cols="12" md="3" v-if="localData.metaData.agentType === 0">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>جواز کسب</span>
								</div>
								<ImageUploader :downloadable="true" ref="javazKasbFileUploader" v-model="localData.metaData.javazKasbBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.javazKasbBase64)" @delete="() => localData.metaData.javazKasbFileName = ''" />
							</v-col>
							<v-col cols="12" md="3" v-if="localData.metaData.agentType === 1">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>تصویر اساسنامه</span>
								</div>
								<ImageUploader :downloadable="true" ref="asasnameFileUploader" v-model="localData.metaData.asasnameBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.asasnameBase64)" @delete="() => localData.metaData.asasnameFileName = ''" />
							</v-col>
							<v-col cols="12" md="3" v-if="localData.metaData.agentType === 1">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>تصویر روزنامه رسمی</span>
								</div>
								<ImageUploader :downloadable="true" ref="roznameRasmiFileUploader" v-model="localData.metaData.roznameRasmiBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.roznameRasmiBase64)" @delete="() => localData.metaData.roznameRasmiFileName = ''" />
							</v-col>
							<v-col cols="12" md="3">
								<div style="border-bottom:1px dashed #ddd; text-align: center; margin-bottom: 10px;display: flex;justify-content: center">
									<v-icon style="transform:rotate(-45deg)">mdi-attachment</v-icon>
									<span>تصویر چک ضمانت</span>
								</div>
								<ImageUploader :downloadable="true" ref="pledgeChequeFileUploader" v-model="localData.metaData.pledgeChequeBase64" :errorImage="require('@/assets/no-image.png')" @imageClicked="viewImage(localData.metaData.pledgeChequeBase64)" @delete="() => localData.metaData.pledgeChequeFileName = ''" />
							</v-col>
						</v-row>
						<div class="my-5 mb-5" v-if="checkActivePart('agentFactorGateway')">
							<v-divider class="mb-4"></v-divider>
							<v-row>
								<v-col cols="12" md="6" class="">
									<v-switch v-model="localData.metaData.useDefaultCommission" label="استفاده از درصد کارمزد صورتحساب الکترونیکی پیش فرض" color="secondary" :value="true" hide-details></v-switch>
								</v-col>
								<v-col cols="12" md="3" class="">
									<v-text-field v-if="!localData.metaData.useDefaultCommission" class="left-input" v-model="localData.metaData.agentFactorCommission" type="number" label="درصد کارمزد" :error-messages="errorMessages" :rules="[(val) => val >= 0 && val < 100 || 'درصد کارمزد صحیح نمی باشد']" />
								</v-col>
								<v-col cols="12" md="3" class="">
									<v-text-money class="left-input" v-if="!localData.metaData.useDefaultCommission" v-model="localData.metaData.maxAgentFactorCommission" label="حداکثر مبلغ کارمزد (به تومان)" :error-messages="errorMessages" :rules="[(val) => localData.metaData.maxAgentFactorCommission >= 0 || 'مبلغ حداکثر کارمزد صحیح نمی باشد']" />
								</v-col>
							</v-row>
						</div>
						<v-card color="#eee" class="pa-3 mt-3">
							<v-row>
								<v-col cols="12" class="d-flex">
									<div class="pt-2">
										وضعیت تایید نماینده:
									</div>
									<v-radio-group v-model="localData.metaData.status" hide-details row>
										<v-radio class="small rtl" label="در انتظار بررسی" color="secondary" :value="0"></v-radio>
										<v-radio class="small rtl" label="تایید شده" color="secondary" :value="1"></v-radio>
										<v-radio class="small rtl" label="رد شده" color="secondary" :value="2"></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="12" v-if="localData.metaData.status === 2">
									<v-textarea v-model="localData.metaData.rejectReason" outlined :error-messages="errorMessages" label="دلیل رد" />
								</v-col>
								<v-col cols="12" class="grey--text text-right text-small" v-if="localData.metaData">
									<small>آخرین تغییر وضعیت توسط: {{ localData.metaData.checkedBy }}</small><small class="mr-3">در تاریخ: {{
										localData.metaData.lastAdminChangeDateTime_Persian.time }} {{
											localData.metaData.lastAdminChangeDateTime_Persian.date }}</small>
								</v-col>
							</v-row>
						</v-card>
					</v-form>
				</v-tab-item>
				<v-tab-item :key="2">
					<div class="mb-2 text-center">وام های قابل درخواست توسط نماینده را اضافه کنید:</div>
					<div class="text-center">
						<small class="blue--text" @click="offDates" style="cursor:pointer">مدیریت تعطیلی های
							تقویم</small>
					</div>
					<v-card v-for="(item, index) in localData.agentLoans" :key="item.id + index" class="mb-3 pa-3" elevation="2" style="border: 1px solid #dca6e5">
						<v-row>
							<v-col cols="11" class="py-0 my-0">
								<v-row class="my-0">
									<v-col cols="12" md="12" class="py-0 my-0">
										<v-select v-model="item.loan" clearable required single-line return-object :items="loans" label="نوع وام" item-text="title" item-value="id" />
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="2" class="text-right text-bold">
										<span class="pointer blue--text" @click="openTitleDialog(item)">{{ item.cashTitle || 'پول نقد:' }}</span>
									</v-col>
									<v-col cols="12" md="2" class="py-0 my-0">
										<v-text-field v-model="item.percent" label="درصد نماینده" maxlength="6" :rules="[(val) => val >= 0 || 'درصد نماینده نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد نماینده نمی تواند بیشتر از 100 باشد']" />
									</v-col>
									<v-col cols="12" md="4" class="py-0 my-0">
										<v-text-field type="number" v-model="item.defaultCheckoutDays" label="تعداد روز پیش فرض تسویه" />
									</v-col>
								</v-row>
								<v-row v-for="(other, other_index) in item.otherPercents" :key="other_index">
									<v-col cols="12" md="2" class="text-right text-bold">
										<span class="pointer blue--text" @click="openTitleDialog(item)">{{ item.cashTitle || 'پول نقد:' }}</span>
									</v-col>
									<v-col cols="12" md="2" class="py-0 my-0">
										<v-text-field v-model="other.percent" label="درصد نماینده" maxlength="6" :rules="[(val) => val >= 0 || 'درصد نماینده نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد نماینده نمی تواند بیشتر از 100 باشد']" />
									</v-col>
									<v-col cols="12" md="4" class="py-0 my-0">
										<v-text-field type="number" v-model="other.checkoutDays" label="تعداد روز" />
									</v-col>
									<v-col cols="1" md="1" class="py-0 my-0 pt-3">
										<v-btn icon text color="red" x-small @click="removeOtherPercent(item, other_index)">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" class="text-center">
										<v-btn x-small @click="addOtherPercent(item)">
											<v-icon>mdi-plus</v-icon>
											افزودن ردیف درصد جدید برای {{ item.cashTitle || 'پول نقد' }}
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" md="2" class="text-right text-bold">
										<span class="pointer blue--text" @click="openTitleDialog(item)">{{ item.productTitle || 'کالا:' }}</span>
									</v-col>
									<v-col cols="12" md="2" class="py-0 my-0">
										<v-text-field v-model="item.productPercent" label="درصد نماینده" maxlength="6" :rules="[(val) => val >= 0 || 'درصد نماینده نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد نماینده نمی تواند بیشتر از 100 باشد']" />
									</v-col>
									<v-col cols="12" md="4" class="py-0 my-0">
										<v-text-field type="number" v-model="item.productCheckoutDays" label="تعداد روز پیش فرض تسویه" />
									</v-col>
								</v-row>
								<div v-if="checkActivePart('contact')" class="my-0">
									<v-card color="#eee" class="mb-3 px-3">
										<v-row class="my-0">
											<v-col cols="12" md="12" class="d-flex justify-center">
												<v-switch v-model="item.hasContact" label="دارای معرف" color="secondary" :value="true" hide-details></v-switch>
											</v-col>
										</v-row>
										<v-row v-show="item.hasContact" class="my-0">
											<v-col cols="12" md="6" class="py-0">
												<div v-if="item.contact" style="position: absolute;">معرف</div>
												<v-combobox v-model="item.contact" clearable :items="contacts" label="معرف" single-line return-object :error-messages="errorMessages" item-text="businessName" item-value="id" />
											</v-col>
											<v-col cols="12" md="6" class="py-0">
												<v-text-field v-model="item.contactPercent" label="درصد معرف" maxlength="6" :rules="[(val) => val >= 0 || 'درصد معرف نمی تواند کمتر از 0 باشد', (val) => val <= 100 || 'درصد معرف نمی تواند بیشتر از 100 باشد']" />
											</v-col>
										</v-row>
									</v-card>
								</div>
							</v-col>
							<v-col cols="1" class="my-0 py-0 d-flex align-center">
								<v-btn @click="remove(item, index)" class="" x-small color="pink" icon dark title="حذف">
									<v-icon>
										mdi-trash-can-outline
									</v-icon>
								</v-btn>
							</v-col>
						</v-row>
						<div class="pa-2" style="direction: ltr;display: flex;align-items: center;justify-content: center;">
							<v-btn @click="copyToClipborad(item.loan)" fab color="rgb(0, 202, 227)" elevation="1" small class="mr-2">
								<v-icon color="white">mdi-content-copy</v-icon>
							</v-btn>
							<span style="cursor: pointer;" class="info--text" @click="copyToClipborad(item.loan)">
								{{ getLink(item.loan) }}
							</span>
						</div>
					</v-card>
					<div class="text-center mt-5">
						<v-btn class="mx-auto" color="secondary" dark @click="add">
							<v-icon dark>
								mdi-plus-circle-outline
							</v-icon>
							افزودن وام
						</v-btn>
					</div>
				</v-tab-item>
				<v-tab-item :key="3" v-if="localData.id !== 0">
					<v-card color="white" class="pa-3">
						<tickets ref="tickets" :agentId="localData.id" userType="admin" />
					</v-card>
				</v-tab-item>
				<v-tab-item :key="4" v-if="localData.id !== 0 && checkActivePart('agentFactor')">
					<v-card color="white" class="pa-3">
						<agent-factors ref="agentFactors" :agent="localData" :autoSubmit="true" :hideDateRange="true" />
					</v-card>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
		<v-card-actions>
			<v-spacer />
			<v-btn @click="$emit('callbck', false)">
				بستن
			</v-btn>
			<v-btn color="blue" dark @click="submit" :loading="loading">
				ذخیره
			</v-btn>
		</v-card-actions>

		<v-dialog v-model="offDatesDialog" scrollable max-width="450px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت تعطیلی های تقویم</span></div>
					<v-spacer />
					<v-btn @click="offDatesDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<OffDates v-if="offDatesDialog" @callbck="offDatesDialog = false" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="setTitleDialog" scrollable max-width="400px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تعیین عنوان واژه‌ها</span></div>
					<v-spacer />
					<v-btn @click="setTitleDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row v-if="setTitleDialog">
						<v-col cols="12">
							<v-text-field v-model="selectedAgentLoan.cashTitle" label="عنوان پول نقد" maxlength="50" />
						</v-col>
						<v-col cols="12">
							<v-text-field v-model="selectedAgentLoan.productTitle" label="عنوان کالا" maxlength="50" />
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn color="blue" dark @click="setTitleDialog = false">
						ذخیره و بستن
					</v-btn>
					<v-spacer />
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import api from '@/util/app-api'
import toast from '@/util/toast'
import { call, get } from 'vuex-pathify'
import { emptyId } from '@/util/emptyId'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import _ from 'lodash'
import { obj2FormData } from '@/util/helpers.js'

export default {
	name: 'ModifyAgent',
	components: {
		OffDates: () => import('@/components/forms/OffDates'),
		'date-picker': VuePersianDatetimePicker,
		'tickets': () => import('@/components/ticket/AdminTickets.vue'),
		'agent-factors': () => import('@/views/admin/Report/AgentFactors.vue'),
	},
	props: {
		data: { type: Object },
	},
	data() {
		return {
			offDatesDialog: false,
			setTitleDialog: false,
			errorMessages: '',
			localData: { metaData: { agentType: 0, lastAdminChangeDateTime_Persian: {} } },
			datePickerValidatioin: '',
			show1: false,
			show2: false,
			loading: false,
			activeTab: 0,
			loans: [],
			bankAccounts: [],
			contacts: [],
			selectedAgentLoan: null,
			services: {
				one: { title: 'موبایل و کالای دیجیتال', key: 'موبایل و کالای دیجیتال', value: '' },
				two: { title: 'لوازم خانگی و دکوراسیون', key: 'لوازم خانگی و دکوراسیون', value: '' },
				three: { title: 'خودرو و موتور سیکلت', key: 'خودرو و موتور سیکلت', value: '' },
				four: { title: 'طلا و جواهرات', key: 'طلا و جواهرات', value: '' },
				five: { title: 'ارائه خدمات', key: 'ارائه خدمات', value: '' },
			},
		}
	},
	mounted() {
		this.loadLoans().then(res => {
			this.loadContacts().then(res2 => {
				this.prepareData()
			})
		})
	},
	computed: {
		...get('siteConfig', [
			'baseUrl', 'isCloud'
		]),
		...get('auth', [
			'getCurrentUser',
		]),
		customerCode() {
			var user = this.getCurrentUser
			if (user && user.userData && user.userData.customer) { return `${user.userData.customer.code}` }
			return ''
		},
		isSuperAdmin: get('auth/isSuperAdmin')
	},
	methods: {
		copyToClipborad(plan) {
			const fallbackCopyTextToClipboard = () => {
				var el = document.createElement('textarea')
				el.value = text
				el.setAttribute('readonly', '')
				el.style = {
					position: 'absolute',
					left: '-9999px'
				}
				document.body.appendChild(el)
				el.select()
				document.execCommand('copy')
				document.body.removeChild(el)
				toast.success('لینک به حافظه کپی شد.')
			}
			var text = this.getLink(plan)
			if (!navigator.clipboard) {
				fallbackCopyTextToClipboard(text)
				return
			}
			navigator.clipboard.writeText(text).then(function () {
				toast.success('لینک به حافظه کپی شد.')
			}, function (err) {
				console.error('Async: Could not copy text: ', err)
			})
		},
		checkCodeMeli(code) {
			if (!code)
				return true

			var L = code.length

			if (L < 8 || parseInt(code, 10) == 0) return false
			code = ('0000' + code).substr(L + 4 - 10)
			if (parseInt(code.substr(3, 6), 10) == 0) return false
			var c = parseInt(code.substr(9, 1), 10)
			var s = 0
			for (var i = 0; i < 9; i++)
				s += parseInt(code.substr(i, 1), 10) * (10 - i)
			s = s % 11
			return (s < 2 && c == s) || (s >= 2 && c == (11 - s))
		},
		getLink(plan) {
			if (!plan)
				return `${this.baseUrl}/cl/plans/${(this.isCloud ? this.customerCode + '/' : '0/')}?agn=` + this.localData.id

			return `${this.baseUrl}/cl/plan/${(this.isCloud ? this.customerCode + '/' : '0/')}${plan.code}/?agn=` + this.localData.id
		},
		loadContacts() {
			return api.get('admin/Contact/list/', null)
				.then(
					response => {
						this.contacts = response
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		loadLoans() {
			return api.get('admin/loan/list', null)
				.then(
					response => {
						this.loans = response
					})
				.catch(err => {
					toast.error(err.message)
				})
		},
		add() {
			this.localData.agentLoans.push({
				id: emptyId,
				loanId: '',
				loan: null,
				agentId: this.localData.id,
				percent: 0,
				otherPercents: []
			})
		},
		remove(item, index) {
			this.localData.agentLoans.splice(index, 1)
		},
		submit() {
			if (!this.$refs.form.validate()) { this.activeTab = 0; return }
			if (!this.$refs.formMetaData?.validate()) { this.activeTab = 1; return }
			if (!(Object.values(this.services) || []).filter(x => x.value).length) {
				toast.error('نوع محصولات کسب و کار را انتخاب نمایید.')
				this.activeTab = 1
				return
			}
			if (this.localData.agentLoans?.length) {
				this.localData.agentLoans.forEach(x => {
					x.loanId = x.loan?.id
					x.contact = x.contact
				})
				if (this.localData.agentLoans.some(x => !x.loanId || !x.percent)) {
					toast.error('نوع وام و درصد باید برای تمام وام های نماینده انتخاب شده باشد.')
					this.activeTab = 2
					return
				}
			}
			this.loading = true
			let data = {}
			data = Object.assign(data, this.localData)
			data.metaData.agentCategoryActivities = (Object.values(this.services) || []).filter(x => x.value).map(x => x.value).join(',')
			data.bankAccountsJson = JSON.stringify(this.bankAccounts)
			delete data.metaData.thumbnailBase64
			delete data.metaData.kartMelliBase64
			delete data.metaData.ejarenameBase64
			delete data.metaData.javazKasbBase64
			delete data.metaData.asasnameBase64
			delete data.metaData.roznameRasmiBase64
			delete data.metaData.pledgeChequeBase64
			const formData = obj2FormData(data)
			var fileUploader_thumbnail = this.$refs['thumbnailFileUploader'] ? this.$refs['thumbnailFileUploader'] : null
			if (fileUploader_thumbnail && fileUploader_thumbnail.hasFile()) {
				formData.append('metaData.thumbnailFile', fileUploader_thumbnail.getFile())
			}
			var fileUploader_kartmelli = this.$refs['kartmelliFileUploader'] ? this.$refs['kartmelliFileUploader'] : null
			if (fileUploader_kartmelli && fileUploader_kartmelli.hasFile()) {
				formData.append('metaData.kartMelliFile', fileUploader_kartmelli.getFile())
			}
			var fileUploader_ejarename = this.$refs['ejarenameFileUploader'] ? this.$refs['ejarenameFileUploader'] : null
			if (fileUploader_ejarename && fileUploader_ejarename.hasFile()) {
				formData.append('metaData.ejarenameFile', fileUploader_ejarename.getFile())
			}
			var fileUploader_javazKasb = this.$refs['javazKasbFileUploader'] ? this.$refs['javazKasbFileUploader'] : null
			if (fileUploader_javazKasb && fileUploader_javazKasb.hasFile()) {
				formData.append('metaData.javazKasbFile', fileUploader_javazKasb.getFile())
			}
			var fileUploader_asasname = this.$refs['asasnameFileUploader'] ? this.$refs['asasnameFileUploader'] : null
			if (fileUploader_asasname && fileUploader_asasname.hasFile()) {
				formData.append('metaData.asasnameFile', fileUploader_asasname.getFile())
			}
			var fileUploader_roznameRasmi = this.$refs['roznameRasmiFileUploader'] ? this.$refs['roznameRasmiFileUploader'] : null
			if (fileUploader_roznameRasmi && fileUploader_roznameRasmi.hasFile()) {
				formData.append('metaData.roznameRasmiFile', fileUploader_roznameRasmi.getFile())
			}
			var fileUploader_pledgeCheque = this.$refs['pledgeChequeFileUploader'] ? this.$refs['pledgeChequeFileUploader'] : null
			if (fileUploader_pledgeCheque && fileUploader_pledgeCheque.hasFile()) {
				formData.append('metaData.pledgeChequeFile', fileUploader_pledgeCheque.getFile())
			}
			api.post('admin/agent/' + (this.localData.id === 0 ? 'create' : 'edit'), formData, { contentType: 'multipart/form-data' })
				.then(response => {
					toast.success('اطلاعات با موفقیت ذخیره شد.')
					this.$emit('callbck', true)
				})
				.catch(err => {
					toast.error(err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		prepareData() {
			if (!this.data) {
				this.data = { id: 0 }
			}
			if (!this.data.id) {
				this.data.id = 0
			}
			api.get('admin/agent/get/' + this.data.id, null)
				.then(response => {
					this.localData = response
					if (!response.metaData)
						response.metaData = { agentType: 0, lastAdminChangeDateTime_Persian: {} }
					if (this.data.id === 0) Object.assign(this.localData, this.data)
					let agentLoans = _.cloneDeep(this.localData.agentLoans)
					agentLoans?.forEach(x => {
						x.loan = this.loans.find(l => l.id === x.loanId)
						if (x.contact) {
							x.contact = this.contacts.find(con => con.id === x.contact.id)
						}
						x.hasContact = !!x.contact
					})
					this.localData.agentLoans = agentLoans
					this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
					let activities = this.localData.metaData?.agentCategoryActivities?.split(',') || []
					for (let service of Object.values(this.services)) {
						service.value = activities.includes(service.key) ? service.key : ''
					}
				})
				.catch(err => {
					toast.error(err.message)
				})
		},
		removeBankAccount(item, index) {
			this.bankAccounts.splice(index, 1)
		},
		addBankAccount() {
			let newItem = {
				accountNumber: '',
				bank: '',
				branch: '',
			}
			this.bankAccounts.push(newItem)
		},
		offDates() {
			this.offDatesDialog = true
		},
		isEmailValid() {
			return this.localData.email &&
				/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(this.localData.email)
		},
		addOtherPercent(agentLoan) {
			agentLoan.otherPercents.push({
				checkoutDays: 0,
				percent: 0
			})
		},
		removeOtherPercent(agentLoan, index) {
			agentLoan.otherPercents.splice(index, 1)
		},
		openTitleDialog(item) {
			this.selectedAgentLoan = item
			this.setTitleDialog = true
		},
	},
}
</script>
<style></style>
